import { Select } from './';

import React from 'react';
//import PropTypes from 'prop-types';

const SessionSelect = ({ options, ...props }) => {
  const selectOptions = options.map(session => ({
    key: session.id,
    disabled: session.disabled,
    value: session.primaryKey,
    text: session.number,
    description: session.title,
  }));
  return <Select options={selectOptions} {...props} />;
};

SessionSelect.propTypes = {
  //meta: PropTypes.shape({}).isRequired,
};

export default SessionSelect;



// WEBPACK FOOTER //
// ./src/components/SessionSelect.js